import { render, staticRenderFns } from "./ChapuzonKids2025View.vue?vue&type=template&id=428d68b4&"
import script from "./ChapuzonKids2025View.vue?vue&type=script&lang=ts&"
export * from "./ChapuzonKids2025View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports